import { signViewerUrlApiDocumentsSignUrlPost } from "@noa/api-core";
import { useQuery } from "@tanstack/react-query";
import { DocumentQueryKey } from "../../query-keys";
import { ApiError } from "../../errors";

const fetchSignedViewerUrl = async (blobPath: string) => {
  const { data } = await signViewerUrlApiDocumentsSignUrlPost({
    body: { blob_path: blobPath },
    throwOnError: true,
  });
  return data.signed_url;
};

export const useSignViewerUrl = (blobPath: string | undefined) => {
  const { data, isPending, isError, error, ...rest } = useQuery<string, ApiError>({
    queryKey: DocumentQueryKey.signedUrl(blobPath ?? ""),
    queryFn: () => fetchSignedViewerUrl(blobPath!),
    enabled: !!blobPath,
  });

  return {
    signedUrl: data,
    isLoadingSignedUrl: isPending && !!blobPath,
    isErrorSignedUrl: isError,
    errorSignedUrl: error,
    ...rest,
  };
};
